/// <reference path="../../../Scripts/Public/jquery-1.6.2.min.js" />
/// <reference path="../../General.js" />
/// <reference path="../../SumoDataAccess.js" />
/// <reference path="../../SumoClass.js" />
/// <reference path="../ControlBase.js" />

if (isNullOrUndefined(sumo)) {
    throw ('Paginator.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.controls)) {
    throw ('Paginator.js requies the sumo.controls namespace defined in ControlBase.js');
}

// Paginator Constructor Options (this.Options)
// aOptions.ItemCount = 0;
// aOptions.ItemsPerPage = 0;

// events:
// pagechanged
// countchanged

/**
 * @class
 * @namespace 
 * @param  {} aId
 * @param  {} aParentId
 * @param  {} aOptions
 * @example
 *  mControls.EventsListViewPaginator = new sumo.controls.Paginator('uEventListViewPaginator', 'uEventListViewPaginatorHolder', {
            'ItemCount': count(lEvents),
            'ItemsPerPage': gPaginationSettings.DashboardEventsItems
        });
        mControls.EventsListViewPaginator.bind('pagechanged', uEventListViewPaginator_OnPageChanged);
        mControls.EventsListView.bind('selectedchanged', uEventNoteText_OnChange);
 */
sumo.controls.Paginator = function (aId, aParentId, aOptions) {
    "use strict";

    var mThis = this,
        lHtml = [];

    lHtml.push('<div class="sumo-paginator-control" id="##id##">');
    lHtml.push('    <div class="sumo-paginator-control-header" id="##id##Header">' + localizeWrapper('cPagerPage') + ' <span id="##id##CurrentPage"></span> ' + localizeWrapper('cPagerOf') + ' <span id="##id##PageCount"></span>.');
    lHtml.push('    <span class="sumo-paginator-control-count" id="##id##ItemCountHolder"><span id="##id##ItemCount"></span>' + localizeWrapper('cPagerItemsFound') + ' </span>');
    lHtml.push('    </div>');
    lHtml.push('    <table class="sumo-paginator-control-navigation" id="##id##Navigation">');
    lHtml.push('        <tr>');
    lHtml.push('            <td align="center">');
    lHtml.push('                <div class="sumo-paginator-control-first" id="##id##First" title="first"></div>');
    lHtml.push('            </td>');
    lHtml.push('            <td align="center">');
    lHtml.push('                <div class="sumo-paginator-control-previous" id="##id##Previous" title="previous"></div>');
    lHtml.push('            </td>');
    lHtml.push('            <td align="center" class="##id##-dateTD">');
    lHtml.push('                <div class="sumo-paginator-control-date" id="##id##DateSystemRange" title "date range"></div>');
    lHtml.push('            </td>');
    lHtml.push('            <td align="center">');
    lHtml.push('                <div class="sumo-paginator-control-next" id="##id##Next" title="next"></div>');
    lHtml.push('            </td>');
    lHtml.push('            <td align="center">');
    lHtml.push('                <div class="sumo-paginator-control-last" id="##id##Last" title="last"></div>');
    lHtml.push('            </td>');
    lHtml.push('        </tr>');
    lHtml.push('    </table>');
    lHtml.push('</div>');
    // <span class="sumo-paginator-control-settings" id="##id##Settings">Items/Page <span id="##id##ItemsPerPage">[dropdown]</span></span>

    sumo.controls.Paginator.prototype.baseClass.call(this, aId, aParentId, lHtml.join(''), aOptions);

    if (this.isNothing(this.Options)) {
        throw (this.className() + ': invalid call to constructor. no params passed to control id: ' + this.Id);
    }

    this.Id = aId;
    this.CurrentPage = 1;
    this.ItemCount = 0;
    this.ItemsPerPage = 0;
    this.DateSystem = false;
    //this.FlagToMark = null;
    //this.FlagToMarkValue = '';
    this.Dates = null;
    this.PageCount = 1;

    if (!this.isNothing(this.Options.ItemCount)) {
        this.ItemCount = this.Options.ItemCount;
    }
    if (!this.isNothing(this.Options.ItemsPerPage)) {
        this.ItemsPerPage = this.Options.ItemsPerPage;
    }
    if (!this.isNothing(this.Options.FlagToMark)) {
        this.FlagToMark = this.Options.FlagToMark;
        this.FlagToMarkValue = this.Options.FlagToMarkValue;
    }
    if (!this.isNothing(this.Options.DateSystem)) {
        this.DateSystem = this.Options.DateSystem;
        this_getWeek();
    }
    if (this.ItemsPerPage > 0) {
        this.PageCount = Math.ceil(this.ItemCount / this.ItemsPerPage);
        if (this.PageCount === 0) {
            this.PageCount = 1;
        }
    } else {
        throw (this.className() + ': invalid items per page value of 0. control id: ' + this.Id);
    }

    function updatePageNumbers() {
        var lBaseElement = $('#' + mThis.Id).first();
        lBaseElement.find('#' + mThis.Id + "CurrentPage").text(mThis.CurrentPage);
        lBaseElement.find('#' + mThis.Id + "PageCount").text(mThis.PageCount);
        lBaseElement.find('#' + mThis.Id + "ItemCount").text(mThis.ItemCount);
        if (mThis.DateSystem)
            lBaseElement.find('#' + mThis.Id + "DateSystemRange").text(mThis.Dates.DateString);
    }

    function doPageChange() {
        updatePageNumbers();
        mThis.trigger('pagechanged', mThis.CurrentPage);
    }

    function this_OnFirstClick(aEvent) {
        mThis.CurrentPage = 1;
        doPageChange();
        aEvent.stopImmediatePropagation();
    }

    function this_OnLastClick(aEvent) {
        mThis.CurrentPage = mThis.PageCount;
        doPageChange();
        aEvent.stopImmediatePropagation();
    }

    function this_OnPreviousClick(aEvent) {
        --mThis.CurrentPage;
        if (mThis.CurrentPage < 1) {
            mThis.CurrentPage = 1;
        }
        if (mThis.DateSystem) {
            mThis.Dates = getWeek(new Date(mThis.Dates.FirstDay).addDays(-7));
        }
        doPageChange();
        aEvent.stopImmediatePropagation();
    }

    function this_OnNextClick(aEvent) {
        ++mThis.CurrentPage;
        if (mThis.CurrentPage > mThis.PageCount) {
            mThis.CurrentPage = mThis.PageCount;
        }
        if (mThis.DateSystem) {
            mThis.Dates = getWeek(new Date(mThis.Dates.FirstDay).addDays(7));
        }
        doPageChange();
        aEvent.stopImmediatePropagation();
    }

    function this_getWeek() {
        mThis.Dates = getWeek();
    }

    this.DatesFilter = function () {
        return mThis.Dates;
    }

    this.ResetDates = function () {
        mThis.Dates = getWeek();
    }

    this.paginate = function (aHash) {
        var
        lResult = [],
        lKey = null,
        lIndex = 0,
        lMaxTake,
        lMinTake,
        lKeys = getKeys(aHash),
        lKeysLen = lKeys.length;

        if (this.ItemCount !== lKeysLen) {
            this.ItemCount = lKeysLen;
            this.PageCount = Math.ceil(this.ItemCount / this.ItemsPerPage);
            if (this.PageCount === 0) {
                this.PageCount = 1;
            }
            this.CurrentPage = 1;
        }
        lMaxTake = ((this.CurrentPage - 1) * this.ItemsPerPage) + this.ItemsPerPage;
        lMinTake = ((this.CurrentPage - 1) * this.ItemsPerPage);

        if (lMaxTake > lKeysLen) {
            lMaxTake = lKeysLen;
        }
        for (lIndex = lMinTake; lIndex < lMaxTake; ++lIndex) {
            lKey = lKeys[lIndex];
            lResult[lKey] = aHash[lKey];
        }

        updatePageNumbers(this);

        return lResult;
    };

    this.setPage = function (aPage) {
        if (typeof aPage === 'number' && aPage > 0 && aPage <= mThis.PageCount) {
            mThis.CurrentPage = aPage;
            doPageChange();
        }
    };


    this.render = function () {
        var lBaseElement,
            lHtml = this.Html;

        $('#' + aParentId).html(lHtml);
        lBaseElement = $('#' + this.Id).first();
        lBaseElement.data('control', this);

        lBaseElement.find('#' + this.Id + "CurrentPage").text(this.CurrentPage);
        lBaseElement.find('#' + this.Id + "PageCount").text(this.PageCount);

        lBaseElement.find('#' + this.Id + "Previous").click(this_OnPreviousClick);

        $('.' + this.Id + '-dateTD').hide();
        lBaseElement.find('#' + this.Id + "Last").hide();
        lBaseElement.find('#' + this.Id + "First").click(this_OnFirstClick).hide();
        if (this.DateSystem) {
            lBaseElement.find('#' + this.Id + "DateSystemRange").text(this.Dates.DateString);
            $('.' + this.Id + '-dateTD').show();
        } else {
            lBaseElement.find('#' + this.Id + "Last").show();
            lBaseElement.find('#' + this.Id + "Last").click(this_OnLastClick);
            lBaseElement.find('#' + this.Id + "First").show();
            lBaseElement.find('#' + this.Id + "First").click(this_OnFirstClick);
        }
        lBaseElement.find('#' + this.Id + "Next").click(this_OnNextClick);


        veritracks.localization.localize('.sumo-paginator-control');
        this.trigger('render');
    };

    this.render();
};
sumo.controls.Paginator.prototype = new sumo.controls.ControlBase();
sumo.controls.Paginator.prototype.constructor = sumo.controls.Paginator;
sumo.controls.Paginator.prototype.baseClass = sumo.controls.ControlBase;
